import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityTransactionsSingleReport  {
    _originalTypeClassName = "zERP.BO.TransactionEntityTransactionsSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityTransactionsSingleReport.translate = translateService;
}
this.Date = null;
this.Invoice = null;
this.RelatedInvoice = null;
this.Description = null;
this.Charge = null;
this.Credit = null;
this.CumulativeCharge = null;
this.CumulativeCredit = null;
this.PayableAmount = null;
this.Remaining = null;
this.Taxes = null;
this.CumulativeTax = null;
this.TransactionEntityTransactionsSingleReportKey = null;
this._key = this.TransactionEntityTransactionsSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Invoice:any;
RelatedInvoice:any;
Description:any;
Charge:any;
Credit:any;
CumulativeCharge:any;
CumulativeCredit:any;
PayableAmount:any;
Remaining:any;
Taxes:any;
CumulativeTax:any;
private _TransactionEntityTransactionsSingleReportKey:any;
get TransactionEntityTransactionsSingleReportKey(): any {
    return this._TransactionEntityTransactionsSingleReportKey;
  }
set TransactionEntityTransactionsSingleReportKey(value: any) {
    this._TransactionEntityTransactionsSingleReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityTransactionsSingleReportKey == null || $this.TransactionEntityTransactionsSingleReportKey == 0;
            }


}